module.exports = __webpack_public_path__ + "img/营销伙伴06.d244ee40.png";